import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import StatsCard from "components/StatsCard";
import { ReactComponent as SlideShow } from "assets/img/icons/slideshow.svg";
import SlideshowStatsDetails from "./SlideshowStatsDetails";

export default ({ team_id, showSlideshow = true }) => {
  const [stats, setStats] = useState({});
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsOpened, setDetailsOpened] = useState(false);

  useEffect(() => {
    setLoading(true);

    (async () => {
      try {
        const response = await TeamService.getSlidshowStats(team_id, time);

        setStats(response?.data?.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team_id, time]);

  return (
    <StatsCard
      title="Slideshow Stats"
      Icon={SlideShow}
      loading={loading}
      stats={stats}
      setTime={setTime}
      time={time}
      onDetailsOpen={() => setDetailsOpened(true)}
      onDetailsClosed={() => setDetailsOpened(false)}
      statsClass="mt-30"
      backgroundClass="card-black"
    >
      <SlideshowStatsDetails
        showSlideshow={showSlideshow}
        team_id={team_id}
        opened={detailsOpened}
        setTime={setTime}
        time={time}
      />
    </StatsCard>
  );
};
